var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{attrs:{"id":"prompt"}},[_vm._v("질문이 등록되었습니다. 답변은 "),_c('router-link',{attrs:{"to":{name: 'answerView', params: {imgID: _vm.imgID }}}},[_vm._v("여기")]),_vm._v("에서 확인해주세요. 카카오톡으로 보내드린 링크에서도 확인하실 수 있습니다.")],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29228e38","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PostQuestion/PostFinished.vue
// module id = 4VMy
// module chunks = 1